<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center" color="blue-grey" dark>
          顧客選択
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="customers"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isGroupsLoding" loading-text="読込中"
          >
          <template #[`item.favoriteFlg`]="{ item }">
            <v-btn icon outlined @click="changeFavoriteGroup(item)" v-if="item.favoriteFlg"><v-icon color="orange">mdi-star</v-icon></v-btn>
            <v-btn icon outlined @click="changeFavoriteGroup(item)" v-if="!item.favoriteFlg"><v-icon>mdi-star-outline</v-icon></v-btn>
          </template>
          <template #[`item.toContactRegist`]="{ item }">
            <v-btn  color="accent" class="black--text" large  @click="onClicktoContactRegist(item)">問い合わせ登録</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
</v-container>
</template>

<script>
//import { httpsCallable, getFunctions } from "firebase/functions";
//import { format } from 'date-fns';
//import { ja } from 'date-fns/locale';
export default {
  data() {
    return {
      headers: [
        { text: "顧客略名", value: "groupSName" },
        { text: "顧客名", value: "groupName" },
        { text: "お気に入り", value: "favoriteFlg" },
        { text:"" ,value:"toMemberList"},
        { text:"" ,value:"toContactRegist"},
      ],
      customersersers: [],
      isGroupsLoding: false,
      perPage: 30,
    };
  },
  watch: {
  },
  // 初期表示時データ読み込み
  async created() {
    await this.reload();
  },
  methods: {
    // ページ再読込
    async reload() {

    },
    async changeFavoriteGroup(item)  {      
      console.log(item);
    },
    // 問い合わせ登録
    onClicktoIssueRegist(item) {
      console.log(item.groupId);
      this.$router.push({
        name: "IssueRegist",
        params: {
          groupId:item.groupId,
        }
      });
    },
    // 所属者一覧
    onClicktoMemberList(item) {
      this.$router.push({
        name: "MemberList",
        params: {
          groupName:item.groupName,
          groupId:item.groupId,
          beforeName:"CustomerSelect"
        }
      });
    },
  },
};
</script>